export default __webpack_public_path__ + "static/media/PPI-driveway-004.13680a27.jpg";